import script from "./slider-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./slider-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./slider-setting-ly.vue?vue&type=style&index=0&id=47089f74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47089f74"]])

export default __exports__